import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeeService } from '../service/fee.service';

export interface GroupDeleteDialogData {
  groupId: number;
  groupName: string;
  hasData: boolean;
}

@Component({
  selector: 'app-fee-group-delete-dialog',
  templateUrl: './fee-group-delete-dialog.component.html',
  styleUrls: ['./fee-group-delete-dialog.component.scss']
})
export class GroupDeleteDialogComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  deleting = false;

  constructor(
    private readonly dialogRef: MatDialogRef<GroupDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: GroupDeleteDialogData,
    private readonly feeService: FeeService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  confirmDelete(): void {
    if (this.deleting || this.data.hasData) return;
    this.deleting = true;

    this.feeService.deleteGroup(this.data.groupId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: () => { this.deleting = false; }
      });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
